import TimeUtils from 'app/utils/time';

export const DEFAULT_TIMEOUT = TimeUtils.calcMilliseconds.seconds(30);
export const EXTENDED_TIMEOUT = TimeUtils.calcMilliseconds.minutes(1);
// The Safe Connect confirm: social-login assigns every selected page through
// Meta before it answers.
export const SAFE_CONNECT_CONFIRM_TIMEOUT =
  TimeUtils.calcMilliseconds.minutes(2);
// Onboarding waits less: past it, the person goes on setting up and connects
// again later from the calendar (a second confirm is much quicker).
export const ONBOARDING_SAFE_CONNECT_CONFIRM_TIMEOUT =
  TimeUtils.calcMilliseconds.seconds(30);

export const DEFAULT_HEADERS: Record<string, any> = {
  // this is needed because of backend, based on this its handled as ajax on backend
  'X-Requested-With': 'XMLHttpRequest',
  accept: 'application/json',
};
